/* ds-hint.js — поведение toggletip «?» (snippets/ds-hint.liquid).
   Клик/тап и клавиатура открывают и закрывают (pinned); hover/focus
   показывают временно. Escape закрывает и возвращает фокус на кнопку.
   Открытым держится один popover. Идемпотентно: повторный init пропускает
   уже связанные элементы (секции пере-рендериваются в редакторе темы). */
(function () {
  'use strict';

  var openHint = null;

  function popoverOf(hint) {
    return hint.querySelector('[data-ds-hint-popover]');
  }

  function buttonOf(hint) {
    return hint.querySelector('[data-ds-hint-button]');
  }

  /* Popover — position: fixed, координаты от кнопки: центр под кнопкой,
     зажат в вьюпорт с полем 8 px; если внизу не хватает места — над кнопкой.
     Абсолютное позиционирование в потоке давало в RTL транзиентный вылет за
     левый край, и мобильный Chrome прокручивал страницу по горизонтали. */
  function place(hint) {
    var pop = popoverOf(hint);
    var btn = buttonOf(hint);
    if (!pop || !btn) return;
    var pad = 8;
    var vw = document.documentElement.clientWidth;
    var vh = window.innerHeight;
    var br = btn.getBoundingClientRect();
    var w = pop.offsetWidth;
    var h = pop.offsetHeight;
    var left = br.left + br.width / 2 - w / 2;
    if (left + w > vw - pad) left = vw - pad - w;
    if (left < pad) left = pad;
    var top = br.bottom + pad;
    if (top + h > vh - pad && br.top - pad - h >= pad) top = br.top - pad - h;
    pop.style.left = Math.round(left) + 'px';
    pop.style.top = Math.round(top) + 'px';
  }

  function show(hint, pinned) {
    var pop = popoverOf(hint);
    var btn = buttonOf(hint);
    if (!pop || !btn) return;
    if (openHint && openHint !== hint) hide(openHint, true);
    pop.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    hint.dataset.dsHintPinned = pinned ? 'true' : '';
    place(hint);
    openHint = hint;
  }

  function hide(hint, force) {
    var pop = popoverOf(hint);
    var btn = buttonOf(hint);
    if (!pop || !btn) return;
    if (!force && hint.dataset.dsHintPinned === 'true') return;
    pop.hidden = true;
    btn.setAttribute('aria-expanded', 'false');
    hint.dataset.dsHintPinned = '';
    if (openHint === hint) openHint = null;
  }

  function bind(hint) {
    if (hint.dataset.dsHintInit) return;
    hint.dataset.dsHintInit = 'true';
    var btn = buttonOf(hint);
    var pop = popoverOf(hint);
    if (!btn || !pop) return;

    btn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (!pop.hidden && hint.dataset.dsHintPinned === 'true') {
        hide(hint, true);
      } else {
        show(hint, true);
      }
    });

    /* hover — только там, где он есть; на тач-устройствах mouseenter
       прилетает вместе с тапом и лишь дублирует клик */
    if (window.matchMedia('(hover: hover)').matches) {
      hint.addEventListener('mouseenter', function () {
        if (pop.hidden) show(hint, false);
      });
      hint.addEventListener('mouseleave', function () {
        hide(hint, false);
      });
    }

    btn.addEventListener('focus', function () {
      if (pop.hidden) show(hint, false);
    });
    btn.addEventListener('blur', function () {
      hide(hint, false);
    });

    hint.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !pop.hidden) {
        event.stopPropagation();
        hide(hint, true);
        btn.focus();
      }
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-ds-hint]').forEach(bind);
  }

  document.addEventListener('click', function (event) {
    if (openHint && !openHint.contains(event.target)) hide(openHint, true);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && openHint) hide(openHint, true);
  });

  window.addEventListener('resize', function () {
    if (openHint) place(openHint);
  });

  window.addEventListener('scroll', function () {
    if (openHint) place(openHint);
  }, { passive: true });

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  window.dsHint = { init: init };
})();
